import React, { useState, useEffect } from "react";
import general from "../../../../../general";
import Dialog from "../../../../../lib/Dialog";
import "./css/RedEnvelpoe.css";
import { RightOutlined } from "@ant-design/icons";
import { NavLink } from "../../../../../lib/Navigation";

export default function RedEnvelopeRecord(props) {
  const [data, setData] = useState();
  const [list, setList] = useState([]);
  const [init, setInit] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (props.active && !init) {
      getRedEnvelopeRecord();
    }
  }, [props.active]);

  const getRedEnvelopeRecord = () => {
    Dialog.loading();
    general.axios
      .post("/getRedenvelopRecord", {
        redenvelope_id: props?.query?.id,
      })
      .finally(() => {
        Dialog.close();
      })
      .then((response) => {
        const { status, data } = response.data;
        if (status.succeed == 1) {
          setData(data);
          setList(data.list);
          setInit(true);
        } else {
          Dialog.error(status.error_desc);
        }
      });
  };

  useEffect(() => {
    const div = document.querySelector('.red-envelope-record')
    const header = div.children[0]
    const headerHeight = header.offsetHeight
    setHeaderHeight(headerHeight)
  }, [list]);

  return (
    <div>
      <div
        className="red-envelope-record"
        style={{ display: data ? "" : "none" }}
      >
        <div>
          <img src="resources/251222/re_record_top.png" alt="" />
          <div className="red-envelope-record-header">
            <div className="red-envelope-record-info">
              <img className="logo" src={data?.send_user.avator} alt="" />
              <div className="title">{data?.send_user.title}</div>
            </div>
            {data?.is_exists ? (
              <div>
                <div className="red-envelope-record-amount">
                  <div className="red-envelope-record-value">
                    {data?.amount}
                  </div>
                  <div className="red-envelope-record-unit">
                    {parseInt(data?.reward_type) === 2 ? "元券" : "金币"}
                  </div>
                </div>
                <div className="red-envelope-record-desc">
                  <NavLink
                    to={
                      parseInt(data?.reward_type) === 2
                        ? "/user/voucher"
                        : "/user/bill?type=2"
                    }
                    className="red-envelope-record-tips"
                  >
                    {parseInt(data?.reward_type) === 2
                      ? "已存入我的代金券，点击查看明细"
                      : "已存入金币余额，点击查看明细"}
                  </NavLink>
                  <RightOutlined
                    style={{ fontSize: 10, color: "#BF0F0A" }}
                  ></RightOutlined>
                </div>
              </div>
            ) : (
              <div className="empty">手慢了，已被抢光</div>
            )}
          </div>
          <div className="list-header">{data?.subtitle}</div>
        </div>
        <div className="list" style={{height:`calc(100vh - ${headerHeight}px)`,overflow:'scroll'}}>
          {list.map((item, index) => (
            <div key={index} className="record-item">
              <img className="avatar" src={item.avator} alt="" />
              <div className="record-info">
                <div className="record-name">
                  <div className="nick-name">{item.nick_name}</div>
                  <div className="amount-value">
                    <div className="record-amount">{item.amount}</div>
                    <div className="amount-unit">
                      {parseInt(item.reward_type) == 2 ? "元" : "金币"}
                    </div>
                  </div>
                </div>
                <div className="record-time">
                  <div className="time">{item.create_time}</div>
                  {parseInt(item.reward_type) == 2 && (
                    <div className="record-type">{item.reward_desc}</div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
